import { $api } from 'api/http'
import { ISearch } from 'api/types/search'

class SearchApiService {
  getSearch(query: string) {
    return $api.post<Array<ISearch>>('/search', {
      search: query,
    })
  }
}

export const searchApiService = new SearchApiService()
